// TODO: This is a temporary fix to be replaced with a validation API
export function validateQuoteCharges(quote: any): boolean {
  // Check if any trip has charges with null chargeTypeId or chargeType
  const hasInvalidCharge = quote.trips?.some(trip => {
    // Ensure charges array exists and is not null
    if (!trip.charges || !Array.isArray(trip.charges)) {
      return false
    }

    return trip.charges.some(charge => {
      // Ensure charge itself is not null
      if (charge == null) {
        return true
      }

      return charge.chargeTypeId == null || charge.chargeType == null
    })
  })

  return !hasInvalidCharge
}
